






















































































































































































































import { computed, ref } from '@vue/composition-api'
import { copyTextToClipboard } from 'vtils'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { getPageUrl, pageNameMap } from '@/router'
import { Toast } from 'vant'

export default defineClassComponent(
  () =>
    class {
      envs = (
        [
          ['生产环境', 'prod'],
          ['测试环境', 'test'],
        ] as const
      ).map(([label, env]) => ({
        label: label,
        value: label,
        env: env,
      }))

      types = (
        [
          ['配送-活动主页', pageNameMap.InstantDeliveryIndex, () => ({})],
          [
            '配送-店铺主页',
            pageNameMap.InstantDeliveryMartIndex,
            () => ({
              martId: this.martId.value,
            }),
          ],
          [
            '配送-商品详情页',
            pageNameMap.InstantDeliveryGoodsIndex,
            () => ({
              goodsId: this.goodsId.value,
            }),
          ],
          [
            '配送-订单列表页',
            pageNameMap.InstantDeliveryOrderIndex,
            () => ({}),
          ],
          [
            '配送-订单详情页',
            pageNameMap.InstantDeliveryOrderDetail,
            () => ({
              orderNo: this.orderNo.value,
            }),
          ],
          [
            '攻略-详情链接',
            pageNameMap.StrategyIndex,
            () => ({
              id: this.strategyId.value,
            }),
          ],
          [
            '标电组合-商品详情链接',
            pageNameMap.JointStdGoodsIndex,
            () => ({
              id: this.goodsId.value,
            }),
          ],
          [
            '旅游-商品详情链接',
            pageNameMap.TravelGoodsIndex,
            () => ({
              goodsId: this.goodsId.value,
            }),
          ],
          [
            '标销-店铺链接',
            pageNameMap.BookIndex,
            () => ({
              martId: this.martId.value,
            }),
          ],
          [
            '标销-商品详情链接',
            pageNameMap.BookGoodsIndex,
            () => ({
              goodsId: this.goodsId.value,
            }),
          ],
          ['标销-商家核销首页', pageNameMap.BookVerifyIndex, () => ({})],
          ['标销-订单列表', pageNameMap.BookOrderIndex, () => ({})],
          [
            '组合商品-商品详情链接',
            pageNameMap.JointGoodsIndex,
            () => ({
              goodsId: this.goodsId.value,
            }),
          ],
          ['首页链接', pageNameMap.HomeIndex, () => ({})],
          [
            '专题链接',
            pageNameMap.TopicIndex,
            () => ({
              id: this.topicId.value,
            }),
          ],
          [
            '专题分组链接',
            pageNameMap.TopicIndex,
            () => ({
              id: this.topicId.value,
              groupId: this.topicGroupId.value,
            }),
          ],
          [
            '商品详情链接',
            pageNameMap.GoodsIndex,
            () => ({
              id: this.goodsId.value,
            }),
          ],
          [
            '热销榜单链接',
            pageNameMap.TopicTop,
            () => ({
              id: this.topicId.value,
            }),
          ],
          [
            '盲盒链接',
            pageNameMap.BoxIndex,
            () => ({
              id: this.boxActivityId.value,
            }),
          ],
          [
            '新春年货节-盲盒链接',
            pageNameMap.BoxIndex_2025,
            () => ({
              id: this.boxActivityId.value,
            }),
          ],
          ['秒杀链接', pageNameMap.SeckillIndex, () => ({})],
          [
            '拼团链接',
            pageNameMap.GroupBuyingIndex,
            () => ({
              id: this.groupBuyingActivityId.value,
            }),
          ],
          [
            '订单列表链接',
            pageNameMap.OrderIndex,
            () => ({
              active: this.orderListDefaultActive.value,
            }),
          ],
          [
            '订单详情链接',
            pageNameMap.OrderDetail,
            () => ({
              orderNo: this.orderNo.value,
            }),
          ],
          ['购物车链接', pageNameMap.CartIndex, () => ({})],
          [
            '店铺链接',
            pageNameMap.MartIndex,
            () => ({
              id: this.martId.value,
            }),
          ],
          [
            '搜索结果链接',
            pageNameMap.SearchIndex,
            () => ({
              q: this.searchKeyword.value,
            }),
          ],
          [
            'TV-商品详情链接',
            pageNameMap.TvGoodsIndex,
            () => ({
              id: this.goodsId.value,
            }),
          ],
          [
            'TV-专题链接',
            pageNameMap.TvTopicIndex,
            () => ({
              id: this.topicId.value,
            }),
          ],
          ['TV-订单列表链接', pageNameMap.TvOrderIndex, () => ({})],
          [
            'TV-订单详情链接',
            pageNameMap.TvOrderDetail,
            () => ({
              orderNo: this.orderNo.value,
            }),
          ],
          [
            'TV-店铺链接',
            pageNameMap.TvMartIndex,
            () => ({
              id: this.martId.value,
            }),
          ],
          ['TV-秒杀链接', pageNameMap.TvSeckillIndex, () => ({})],
        ] as const
      ).map(([label, name, queryGenerator]) => ({
        label: label,
        value: label,
        name: name,
        queryGenerator: queryGenerator,
      }))

      orderListActives = [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '待付款',
          value: 1,
        },
        {
          label: '待发货',
          value: 2,
        },
        {
          label: '待收货',
          value: 3,
        },
        {
          label: '待评价',
          value: 4,
        },
        {
          label: '售后',
          value: 5,
        },
      ] as const

      selectedEnv = ref(this.envs[0].value)

      channelId = ref('')

      p = ref('')

      selectedType = ref(this.types[0].value)

      topicId = ref('')

      topicGroupId = ref('')

      goodsId = ref('')

      boxActivityId = ref('')

      strategyId = ref('')

      groupBuyingActivityId = ref('')

      orderListDefaultActive = ref(0)

      orderNo = ref('')

      martId = ref('')

      searchKeyword = ref('')

      resultUrl = computed(() => {
        const selectedEnvItem = this.envs.find(
          env => env.value === this.selectedEnv.value,
        )!
        const selectedTypeItem = this.types.find(
          type => type.value === this.selectedType.value,
        )!
        return getPageUrl(
          selectedTypeItem.name as any,
          {
            ...selectedTypeItem.queryGenerator(),
            ...(this.p.value ? { p: this.p.value } : {}),
          },
          {
            env: selectedEnvItem.env,
            channelId: this.channelId.value,
            noDefaultChannelId: true,
          },
        )
      })

      handlePreviewClick = () => {
        dcb.navigateTo({
          url: this.resultUrl.value,
        })
      }

      handleCopyClick = () => {
        copyTextToClipboard(this.resultUrl.value)
        Toast.success('复制成功')
      }
    },
)
